import { Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwActionItemRequirement, DwMdFormActionHandler, DwMdFormActionState, DwWizardFinishService, DwWizardStateService, DwMdFormSaveActionResult, DwOrmDataService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { map, mergeMap, tap } from "rxjs/operators";
import { SchoolRepositoryService } from "../services/school-repository.service";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { AppMetaDataItemNames, FlightSchoolApplicantEntity, FlightSchoolExaminerEntity, FlightSchoolInstructorEntity } from "../../../meta-data/app-meta-data.service";
import { ConvertCheckInstructorRequest, ConvertCheckInstructorType } from "../models/convert-check-instructor-request.model";
import { ConvertCheckInstructorResult } from "../models/convert-check-instructor-result.model";

@DwAction({
    keyName: 'school-convert-instructor-action',
    display: 'School Convert Instructor',
    actionType: DwActionType.formAction,
    parentItemName: [AppMetaDataItemNames.FlightSchoolInstructor, AppMetaDataItemNames.FlightSchoolExaminer],
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Complete Conversion',
        iconClass: 'fa fa-plane-departure',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Convert to Check Instructor'
    }
})
@Injectable()
export class SchoolConvertInstructorActionService extends DwWizardFinishService {
    constructor(
        dwWizardStateService: DwWizardStateService,
        private dwRoutingService: DwRoutingService,
        private schoolRepository: SchoolRepositoryService,
        private dwEventService: DwEventService
    ) {
        super(dwWizardStateService);
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        const variables = actionState.formApi.getVariableContextValue<CheckInstructorVariableContext>();
        const itemName = actionState.data?._itemName;

        return actionState.formApi.saveData(true)
            .pipe(mergeMap((saveResult => {
                if (saveResult.success) {
                    return this.completeConversion(saveResult, variables, itemName);
                }

                return of (saveResult);
            })));
    }

    completeConversion(saveResult: DwMdFormSaveActionResult, variables: CheckInstructorVariableContext, itemName: string): Observable<DwActionResult> {

        let ob: Observable<ConvertCheckInstructorResult> = of(null);

        if (itemName === AppMetaDataItemNames.FlightSchoolInstructor) {
            ob = this.completeInstructorConversion(saveResult, variables  );
        } else {
            ob = this.completeExaminerConversion(saveResult, variables);
        }

        return ob.pipe(map((conversionResult) => {

            saveResult.message = conversionResult?.ErrorMessage;
            saveResult.success = conversionResult?.Success;
            saveResult.returnAfter = conversionResult?.Success;

            this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchoolInstructor), {});
            this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.FlightSchoolExaminer), {});

            return saveResult;
        }));
    }

    completeInstructorConversion(saveResult: DwMdFormSaveActionResult, variables: CheckInstructorVariableContext): Observable<ConvertCheckInstructorResult> {
        const instructor : FlightSchoolInstructorEntity = saveResult.saveResult as FlightSchoolInstructorEntity;
        const request : ConvertCheckInstructorRequest = {
            ConvertCheckInstructorType: ConvertCheckInstructorType.ConvertFromFlightInstructor,
            FlightSchoolInstructorId: instructor.FlightSchoolInstructorId,
            FlightSchoolExaminerId: variables?.ExistingFlightSchoolExaminerId,
        };

        return this.schoolRepository.convertToCheckInstructor(request)
    }

    completeExaminerConversion(saveResult: DwMdFormSaveActionResult, variables: CheckInstructorVariableContext): Observable<ConvertCheckInstructorResult> {
          const examiner : FlightSchoolExaminerEntity = saveResult.saveResult as FlightSchoolExaminerEntity;

        const request : ConvertCheckInstructorRequest = {
            ConvertCheckInstructorType: ConvertCheckInstructorType.ConvertFromPilotExaminer,
            FlightSchoolInstructorId: variables?.ExistingFlightSchoolInstructorId,
            FlightSchoolExaminerId: examiner.FlightSchoolExaminerId,
            InstructorCertificateNumber: variables?.InstructorCertificateNumber
        };

        return this.schoolRepository.convertToCheckInstructor(request)
    }

}

export interface CheckInstructorVariableContext {
    LinkExistingExaminer?: boolean;
    ExistingFlightSchoolExaminerId?: number;
    ExistingFlightSchoolInstructorId?: number;
    InstructorCertificateNumber?: string;
}